import axios from "axios";

export default axios.create({
    baseURL: process.env.REACT_APP_CUMULUS_DESK_BACK_END_URL,
    headers: {
        "Content-type": "application/json"
    },
    withCredentials: true
});
